<template>
  <div class="userSettings">
    <div class="loginOutBox" @click="loginOut">
      <div class="loginOut">{{ $t.auth.logout }}</div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { LOG_OUT } from "@/store/mutation-types";

export default {
  name: "userSettings",
  data() {
    return {};
  },
  methods: {
    ...mapMutations([LOG_OUT]),
    loginOut() {
      this.LOG_OUT();
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "auth/login",
        name: "Login",
        query: [],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.userSettings {
  margin-top: 5%;
  margin-bottom: 5%;
  .loginOutBox {
    margin: auto;
    width: 80%;
    .loginOut {
      position: relative;
      width: 100%;
      margin: 0 auto;
      border-radius: 100px;
      padding: 10px 0;
      text-align: center;
      background: linear-gradient(left, #009ed4, #5029c3);
      color: #ffffff;
      font-size: 14px;
    }
  }
}
</style>
